export enum HeadingTypes {
    primary = 'primary',
    secondary = 'secondary',
    tertiary = 'tertiary'
}
